import { useAppSelector } from 'store/hooks';
import { OrderItem } from 'store/Orders/types';
import { SettingSelectors } from 'store/Settings';
import { isPermutation } from 'util/helpers';

export function useHaveHiddenItems(
  items: OrderItem[],
  filteredItems: OrderItem[],
) {
  const isSelectedAllCategories = useAppSelector(
    SettingSelectors.selectIsSelectedAllCategories,
  );
  const allCategories = useAppSelector(SettingSelectors.selectAllCategories);
  const selectedCategories = useAppSelector(
    SettingSelectors.selectSelectedCategories,
  );

  const haveHiddenItems =
    items.length !== filteredItems.length &&
    !isSelectedAllCategories &&
    !isPermutation(allCategories, selectedCategories);

  const hiddenItemsCount = items.length - filteredItems.length;

  return {
    haveHiddenItems,
    hiddenItemsCount: hiddenItemsCount > 0 ? hiddenItemsCount : 0,
  };
}
